import { apiClient } from "@lib/api/apiClient";
import type { ApiResponse } from "@lib/api/api-types";
import { normalizeUsername } from "@features/auth/lib/auth-utils";
import type { LoginInput, RawUser } from "@features/auth/types/types";

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: RawUser;
}

export const authApi = {
  login: (input: LoginInput) =>
    apiClient.post<ApiResponse<LoginResponse>>("/auth/login", {
      email: normalizeUsername(input.email),
      password: input.password,
    }),
  me: () => apiClient.get<ApiResponse<RawUser>>("/users/me"),
  logout: () => apiClient.post<ApiResponse<unknown>>("/auth/logout"),
};
